import { ClientService, ServiceValue } from 'app/entities/details/services/client-service.model';

/**
 * Model for Adding Services request.
 *
 * @author jagpreet.singh@vernuso.com
 */
export class AddServiceRequest {
    clientId: number;
    services: Array<ServiceValue>;
}



// WEBPACK FOOTER //
// ./src/app/entities/details/services/addservices/add-service-request.model.ts